// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryItem_category_2Mn3E","name":"CategoryItem_name_3wwGu","arrow":"CategoryItem_arrow_YtIA6"};